import { ActaUser } from 'pa_kit/apps/user/models/user.js';
import ApiService from 'services/api';


export class ApplicantUser extends ActaUser {

    constructor(userData, data) {
        super(userData);

        this.id                     = data.id
        this.fiscal_code            = data.fiscal_code
        this.gender                 = data.gender
        this.citizenship            = data.citizenship
        this.residence_province     = data.residence_province
        this.residence_city         = data.residence_city
        this.residence_zip_code     = data.residence_zip_code
        this.residence_address      = data.residence_address
        this.mother_language        = data.mother_language
        this.protected_class        = data.protected_class
        this.eures_auth             = data.eures_auth
        this.work_experiences       = data.work_experiences
        this.education              = data.education
        this.languages              = data.languages
        this.digital_skills         = data.digital_skills
        this.licenses               = data.licenses
        this.registers              = data.registers
        this.professional_orders    = data.professional_orders
        this.desired_jobs           = data.desired_jobs
        this.eures_consent          = data.eures_consent
        this.created_date           = data.created_date
    }

    async getJobApplications() {
        let result = await ApiService.getJobApplications();
        return result;
    }    
}

export const generateFormSeed = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 16; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}